import { render } from "./customConsult.vue?vue&type=template&id=2915d9c1&scoped=true"
import script from "./customConsult.vue?vue&type=script&lang=js"
export * from "./customConsult.vue?vue&type=script&lang=js"

import "./customConsult.vue?vue&type=style&index=0&id=2915d9c1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2915d9c1"]])

export default __exports__